export default __webpack_public_path__ + "resources/icons/d0-8b38.webp";